<template>
  <div v-a11y-tab:tab-line>
    <a-button
      v-if="!user"
      v-html="$t('join.us')"
      type="primary"
      @click="onClick"
      class="home-button"
    />
  </div>
</template>

<script>
import firebase from 'firebase/app';
import { ROUTER_PATHS } from '@/router/constants';
import { getMeta } from '@/router/utils';

export default {
  computed: {
    user() {
      return firebase.auth().currentUser;
    },
  },
  methods: {
    goNext() {
      this.$router.push(ROUTER_PATHS.LOGIN);
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    onClick() {
      const { canAuthorize } = getMeta(this.$router.currentRoute);
      if (canAuthorize) {
        this.scrollToTop();
      } else {
        this.goNext();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';

.home-button {
  height: 48px;
  border-radius: $border-radius;
  background-color: $orange;
  color: $white;
  font-size: $font-size-large;
  font-weight: bold;
  border: none;
  margin: 0;
  padding: 10px;
}

.home-button:hover {
  background-color: $orange;
}
</style>
